export const bestPracticesContent = `
{% card title="Write one requirement per review" %}
While Reqqy can handle multiple requirements in a single run, you'll get the most detailed feedback by submitting one requirement at a time. This allows for deeper analysis of dependencies and edge cases.
{% /card %}

{% card title="Include context" %}
Provide background information about the feature, target users, and system constraints. Context helps Reqqy generate more relevant clarifying questions and identify domain-specific ambiguities.
{% /card %}

{% card title="Use personas for cross-functional feedback" %}
Select multiple personas to simulate a real requirements review meeting. Different perspectives catch different issues — a QA lead spots untestable criteria while a UX designer flags unclear user flows.
{% /card %}

{% card title="Iterate on your clarity score" %}
Don't stop at the first review. Apply the suggested rewrites, address the clarifying questions, and run another review. Most teams see scores improve from 40–60 to 85+ after two iterations.
{% /card %}

{% card title="Review before sprint planning" %}
Run requirements through Reqqy before they enter your backlog. This prevents ambiguous stories from reaching engineers and reduces the back-and-forth during sprint planning.
{% /card %}
`;
